import { keyValueStorage } from "../../common/logic/KeyValueStore";

const STORAGE_KEY = "portalShutdownNoticeConfirmedUserIds";

/** Bestätigung gilt nur für diesen Browser (kein Backend-Flag, siehe BON-1985). */
export function hasConfirmedPortalShutdownNotice(userId: string): boolean {
  return keyValueStorage.getObject<string[]>(STORAGE_KEY, []).includes(userId);
}

export function confirmPortalShutdownNotice(userId: string) {
  const confirmedUserIds = keyValueStorage.getObject<string[]>(STORAGE_KEY, []);

  if (!confirmedUserIds.includes(userId)) {
    keyValueStorage.setObject(STORAGE_KEY, [...confirmedUserIds, userId]);
  }
}
